"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stylePropTypes = exports.styleDefaultProps = undefined;

var _arenaConfig = require("arena-config");

var _arenaPropTypes = require("arena-prop-types");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var oneOf = _propTypes2.default.oneOf;
var FONT_WEIGHTS = [_arenaConfig.FONT_WEIGHT_1, _arenaConfig.FONT_WEIGHT_2, _arenaConfig.FONT_WEIGHT_3, _arenaConfig.FONT_WEIGHT_4, _arenaConfig.FONT_WEIGHT_5, _arenaConfig.FONT_2_WEIGHT_1, _arenaConfig.FONT_2_WEIGHT_2];
var styleDefaultProps = exports.styleDefaultProps = {
  backgroundColor: 'transparent',
  backgroundColorActive: 'transparent',
  backgroundColorHover: _arenaConfig.DEFAULT_TEXT_COLOR,
  borderColor: _arenaConfig.DEFAULT_TEXT_COLOR,
  borderColorActive: _arenaConfig.DEFAULT_TEXT_COLOR,
  borderColorHover: _arenaConfig.DEFAULT_TEXT_COLOR,
  borderRadius: _arenaConfig.DEFAULT_BORDER_RADIUS,
  borderStyle: _arenaConfig.DEFAULT_BORDER_STYLE,
  borderWidth: _arenaConfig.DEFAULT_BORDER_WIDTH,
  cursor: 'pointer',
  fontSize: '1em',
  fontWeight: _arenaConfig.FONT_WEIGHT_3,
  lineHeight: 1,
  // height = 42px (same as Field at lineHeight: 1.5)
  padding: '.5em .75em',
  textColor: _arenaConfig.DEFAULT_TEXT_COLOR,
  textColorActive: _arenaConfig.DEFAULT_TEXT_COLOR,
  textColorHover: _arenaConfig.WHITE,
  width: 'auto' // onClick: null,
  // reset: false,

};
var stylePropTypes = exports.stylePropTypes = {
  backgroundColor: (0, _arenaPropTypes.stringPT)(),
  backgroundColorActive: (0, _arenaPropTypes.stringPT)(),
  backgroundColorHover: (0, _arenaPropTypes.stringPT)(),
  borderColor: (0, _arenaPropTypes.stringPT)(),
  borderColorActive: (0, _arenaPropTypes.stringPT)(),
  borderColorHover: (0, _arenaPropTypes.stringPT)(),
  borderRadius: (0, _arenaPropTypes.numberOrStringPT)(),
  borderStyle: oneOf(['none', 'hidden', 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset', 'initial', 'inherit']),
  borderWidth: (0, _arenaPropTypes.numberOrStringPT)(),
  cursor: (0, _arenaPropTypes.stringPT)(),
  fontSize: (0, _arenaPropTypes.numberOrStringPT)(),
  fontWeight: oneOf(FONT_WEIGHTS),
  lineHeight: (0, _arenaPropTypes.numberOrStringPT)(),
  padding: (0, _arenaPropTypes.numberOrStringPT)(),
  textColor: (0, _arenaPropTypes.stringPT)(),
  textColorActive: (0, _arenaPropTypes.stringPT)(),
  textColorHover: (0, _arenaPropTypes.stringPT)(),
  width: (0, _arenaPropTypes.numberOrStringPT)() // preventDefault: boolPT(),
  // reset: boolPT(),

};